module.exports = __webpack_public_path__ + "img/mineral-2.71b2fd82.png";